module.exports = __webpack_public_path__ + "img/brand.63e84b93.png";